import { Box, Card, CardContent, Link, Stack, Typography } from "@mui/material";
import { MFAInput } from "../../components/auth/MFAInput";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { SUPPORT_EMAIL } from "../../common/const";
import { Navigate } from "react-router-dom";

export function MFA() {
  const { confirmMFACode, authenticated } = useContext(AuthContext);

  if (authenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <Box display="flex" justifyContent="center">
      <Card sx={{ minWidth: 400, maxWidth: 480 }}>
        <CardContent sx={{ p: 4 }}>
          <Stack spacing={3} alignItems="center">
            <Stack spacing={1} alignItems="center">
              <Typography variant="h5" fontWeight={600}>
                Two-factor authentication
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                textAlign="center"
              >
                Enter the 6-digit code from your authenticator app to continue.
              </Typography>
            </Stack>
            <MFAInput onSubmit={confirmMFACode} />
            <Typography
              variant="body2"
              color="text.secondary"
              textAlign="center"
            >
              Lost access to your authenticator?{" "}
              <Link href={`mailto:${SUPPORT_EMAIL}`}>Contact support</Link>.
            </Typography>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
